import { Context as ContextBase, ContextWatchdog } from 'ckeditor5'

class Context extends ContextBase {}

// Plugins to include in the build.
Context.builtinPlugins = []

// Context configuration.
Context.defaultConfig = {}

export { Context, ContextWatchdog }
